import IdealStudio from "../editor/main";
import {
  correctArrayUnordered,
  correctNumericInput,
  correctTextInput,
} from "./correction_functions";
let html2json = require("html2json").html2json;

export default function () {
  let descendant;
  let extraFunctions = {};

  let parseJson = function (json, state, hasVisorTemplate) {
    if (!json) return;

    // Skip comment nodes - they don't have valid child structures
    if (json.node === "comment" || (json.tag && json.tag.toLowerCase() === "comment")) {
      return;
    }

    if (json.child && Array.isArray(json.child)) {
      for (let i = 0; i < json.child.length; i++) {
        // Skip undefined or null children
        if (!json.child[i]) {
          continue;
        }

        // Skip comment nodes
        if (
          json.child[i].node === "comment" ||
          (json.child[i].tag && json.child[i].tag.toLowerCase() === "comment")
        ) {
          continue;
        }

        if (
          json.child[i].tag &&
          json.child[i].tag === "plugin" &&
          json.child[i].attr &&
          state.__pluginContainerIds
        ) {
          let pluginKey = json.child[i].attr["plugin-data-key"];
          if (pluginKey && state.__pluginContainerIds[pluginKey]) {
            let height = state.__pluginContainerIds[pluginKey].height;
            height = !isNaN(height) ? height + "px" : height;
            json.child[i].attr["plugin-data-height"] = height;
            if (!json.attr) {
              json.attr = {
                style: { height: height },
              };
            } else if (!json.attr.style) {
              json.attr.style = { height: height };
            } else {
              json.attr.style.height = height;
            }
            if (json.attr.style.minHeight) {
              delete json.attr.style.minHeight;
            }
          }
        }

        parseJson(json.child[i], state, hasVisorTemplate);
      }
    }
    if (json.attr && json.attr.className) {
      json.attr.class = json.attr.className;
      delete json.attr.className;
    }
    if (json.tag && json.tag === "plugin") {
      if (!state.__pluginContainerIds) {
        state.__pluginContainerIds = {};
      }
      let key = json.attr["plugin-data-key"];
      if (!key) {
        // eslint-disable-next-line no-console
        console.error(json.tag + " has not defined plugin-data-key");
      } else if (state.__pluginContainerIds[key]) {
        json.attr["plugin-data-id"] = state.__pluginContainerIds[key].id;
      }
    }
  };

  let plugin = {
    create: function (obj) {
      descendant = obj;

      Object.keys(descendant).map(function (id) {
        if (
          id !== "init" &&
          id !== "getConfig" &&
          id !== "getToolbar" &&
          id !== "getInitialState" &&
          id !== "afterRender" &&
          id !== "getConfigTemplate" &&
          id !== "getRenderTemplate"
        ) {
          plugin[id] = descendant[id];
        }
      });
      if (!plugin.checkAnswer) {
        plugin.checkAnswer = function (current, correct, state) {
          if (current instanceof Array && correct instanceof Array) {
            return correctArrayUnordered(
              current,
              correct,
              state.allowPartialScore,
              state.nBoxes || Math.max(correct.length, current.length)
            );
          }

          if (
            typeof current === "string" &&
            typeof correct === "string" &&
            state.characters !== undefined
          ) {
            return correctTextInput(current, correct, !state.characters);
          }

          if (typeof current === "number" && typeof correct === "number") {
            return correctNumericInput(current, correct, state.precision);
          }

          return JSON.stringify(current) === JSON.stringify(correct);
        };
      }
    },
    init: function () {
      if (descendant.init) {
        descendant.init();
      }
    },
    export: function (state, name, hasChildren, id = "") {
      let pluginObj, template, hasVisorTemplate;

      if (!IdealStudio.Visor.Plugins[name]) {
        pluginObj = IdealStudio.Plugins[name];
        hasVisorTemplate = false;
      } else {
        pluginObj = IdealStudio.Visor.Plugins[name];
        hasVisorTemplate = true;
      }
      if (!pluginObj.getRenderTemplate) {
        if (state.__text) {
          template = state.__text;
          // Decode URI-encoded HTML if needed (some content might be encoded)
          // Try to decode, but if it fails, use the original
          try {
            if (template.includes("%3C") || template.includes("%3E")) {
              // Likely URI-encoded, try decoding
              let decoded = decodeURIComponent(template);
              // Only use decoded if it results in valid HTML-like structure
              if (decoded.includes("<") && decoded.includes(">")) {
                template = decoded;
              }
            }
          } catch (e) {
            // If decoding fails, use original template
            // eslint-disable-next-line no-console
            console.warn("Failed to decode template, using original:", e);
          }
        } else {
          template = "<div></div>";
          // eslint-disable-next-line no-console
          console.error("Plugin %s has not defined getRenderTemplate", name);
        }
      } else {
        template = pluginObj.getRenderTemplate(state, { visor: true, boxId: id });
      }

      let regexp = new RegExp(/[$]idealStudio[$][.][\w\s]+[(]([^)]*)/g);
      let match = regexp.exec(template);
      let matches = [];

      while (match !== null) {
        matches.push(match);
        match = regexp.exec(template);
      }
      matches.map(function (matchNew) {
        if (matchNew[1].length === 0) {
          // no traducir pasar directamente la función pasarle directamenete IdealStudio.Visor.Plugins[match[0]].function(event,props,)
          template = template.replace(matchNew[0], matchNew[0] + 'event, "' + id + '"'); // template.replace(match[0], match[0] + "event, this, __getPlugin(this)");
        } else {
          template = template.replace(
            matchNew[0],
            matchNew[0].replace(matchNew[1], 'event, "' + id + '"')
          ); // template.replace(match[0], match[0].replace(match[1], "event, this, __getPlugin(this)"));
        }
        template = template.replace(
          /[$]idealStudio[$][.]/,
          "IdealStudio.Visor.Plugins." + name + "."
        );
      });

      if (template.indexOf("pointer-events") !== -1) {
        template = template.replace(/pointer-events:[\s'"]+none[\s'"]+/g, "");
      }

      // Fix invalid HTML structure: <img><svg>...</svg></img> should be <span><svg>...</svg></span>
      // This happens when SVG icons are wrapped in img tags (img is void element, cannot have children)
      // Handle multiple variations with a more comprehensive approach

      // Strategy: Find all <img> tags that are immediately followed by <svg> and replace them
      // This handles both <img><svg>...</svg></img> and <img><svg>...</svg> (without closing img)

      // First, handle the most common case: <img><svg>...</svg></img>
      // Use a more aggressive regex that handles nested structures
      let previousTemplate = template;
      template = template.replace(
        /<img\s*([^>]*?)>([\s\S]*?)<\/img>/gi,
        (match, attrs, content) => {
          // If img contains SVG or other content, replace img with span
          if (content && content.trim()) {
            // Preserve attributes but convert img to span
            let spanAttrs = attrs ? attrs.trim() : "";
            // Add display:inline-block to preserve icon rendering
            if (spanAttrs && spanAttrs.includes("style=")) {
              // If style exists, add display:inline-block to it
              spanAttrs = spanAttrs.replace(
                /style\s*=\s*["']([^"']*)["']/i,
                (styleMatch, styleContent) => {
                  // Remove trailing semicolon if present, then add display
                  let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                  return `style="${cleanStyle};display:inline-block;"`;
                }
              );
            } else {
              if (spanAttrs) {
                spanAttrs = spanAttrs + " ";
              }
              spanAttrs = spanAttrs + 'style="display:inline-block;"';
            }
            return `<span ${spanAttrs}>${content}</span>`;
          }
          // Otherwise, keep it as self-closing img tag
          // Ensure proper spacing before />
          if (attrs && attrs.trim()) {
            return `<img ${attrs.trim()} />`;
          } else {
            return `<img />`;
          }
        }
      );

      // Also handle cases where img tag might be self-closing but followed by SVG on the same "line"
      // Pattern: <img ... /> followed by <svg>...</svg> (they might be siblings)
      template = template.replace(/<img\s*([^>]*?)\s*\/>\s*<svg/gi, (match, attrs) => {
        let spanAttrs = attrs ? attrs.trim() : "";
        // Always ensure proper spacing: if spanAttrs exists, add space after it; if not, just use empty string
        if (spanAttrs) {
          spanAttrs = spanAttrs + " ";
        }
        return `<span ${spanAttrs}style="display:inline-block;"><svg`;
      });

      // Handle edge case: <img><svg> without closing </img> (malformed HTML)
      // This might happen if the HTML is incomplete
      // Use a more specific pattern that matches <img> immediately followed by <svg>
      template = template.replace(/<img\s*([^>]*?)>\s*<svg/gi, (match, attrs) => {
        let spanAttrs = attrs ? attrs.trim() : "";
        if (spanAttrs && spanAttrs.includes("style=")) {
          spanAttrs = spanAttrs.replace(
            /style\s*=\s*["']([^"']*)["']/i,
            (styleMatch, styleContent) => {
              let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
              return `style="${cleanStyle};display:inline-block;"`;
            }
          );
        } else {
          if (spanAttrs && !spanAttrs.endsWith(" ")) {
            spanAttrs = spanAttrs + " ";
          } else if (!spanAttrs) {
            spanAttrs = "";
          }
          spanAttrs = spanAttrs + 'style="display:inline-block;"';
        }
        return `<span ${spanAttrs}><svg`;
      });

      // Additional fix: Handle <img> with no attributes immediately followed by <svg>
      // Pattern: <img><svg (most common case from user's console output)
      // This must come BEFORE the general regex to handle the no-attributes case
      template = template.replace(/<img\s*>\s*<svg/gi, (match) => {
        return `<span style="display:inline-block;"><svg`;
      });

      // Fix malformed self-closing span tags BEFORE other processing
      // Pattern: <span / style="..."> or <span/ style="..."> -> <span style="...">
      template = template.replace(
        /<span\s*\/\s*style\s*=\s*["']([^"']*)["']/gi,
        '<span style="$1"'
      );

      // Fix: <span / style="..."></span> -> <span style="..."></span>
      template = template.replace(/<span\s*\/\s+style\s*=/gi, "<span style=");

      // Fix any remaining malformed span tags with self-closing syntax
      // Pattern: <span /> or <span/ > (empty self-closing)
      template = template.replace(/<span\s*\/\s*>/gi, "<span>");

      // Fix: <span / attr="value"> -> <span attr="value">
      template = template.replace(/<span\s*\/\s+([^>]*?)>/gi, "<span $1>");

      // Final cleanup: Remove any remaining / before attributes in span tags
      template = template.replace(/<span\s+\/\s*([a-zA-Z-]+)/gi, "<span $1");

      // Also handle the closing tag: </svg></img> should become </svg></span>
      // This must handle both </svg></img> and </svg> </img> (with whitespace)
      template = template.replace(/<\/svg>[\s\n]*<\/img>/gi, "</svg></span>");

      // One more pass: if we still have <img> tags followed by <svg>, try a more aggressive approach
      // This handles cases where the first regex didn't match (e.g., due to encoding or formatting)
      let imgSvgMatches = template.match(/<img[^>]*>[\s\S]*?<svg/gi);
      if (imgSvgMatches && imgSvgMatches.length > 0) {
        // More aggressive: find <img> followed by any content until <svg>, then replace
        template = template.replace(/<img([^>]*)>([\s\S]*?)<svg/gi, (match, attrs, content) => {
          let spanAttrs = attrs ? attrs.trim() : "";
          if (spanAttrs && spanAttrs.includes("style=")) {
            spanAttrs = spanAttrs.replace(
              /style\s*=\s*["']([^"']*)["']/i,
              (styleMatch, styleContent) => {
                let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
                return `style="${cleanStyle};display:inline-block;"`;
              }
            );
          } else {
            if (spanAttrs && !spanAttrs.endsWith(" ")) {
              spanAttrs = spanAttrs + " ";
            } else if (!spanAttrs) {
              spanAttrs = "";
            }
            spanAttrs = spanAttrs + 'style="display:inline-block;"';
          }
          return `<span ${spanAttrs}>${content}<svg`;
        });
      }

      // Update state.__text with the fixed template so it's available for direct reads
      // This ensures that when DragDropVisor.jsx or other components read state.__text directly,
      // they get the fixed version
      if (template !== previousTemplate && state.__text && !pluginObj.getRenderTemplate) {
        // Re-encode if the original was encoded
        if (state.__text.includes("%3C") || state.__text.includes("%3E")) {
          try {
            state.__text = encodeURIComponent(template);
          } catch (e) {
            state.__text = template;
          }
        } else {
          state.__text = template;
        }
      }

      /* if (!hasChildren) {
                return template;
            }*/

      // Remove HTML comments before parsing to prevent html2json errors
      template = template.replace(/<!--[\s\S]*?-->/g, "");

      // Final cleanup pass: Fix any remaining malformed span tags before html2json
      // This catches any edge cases that previous regexes might have missed
      // Pattern: <span / style="..."> -> <span style="...">
      template = template.replace(
        /<span\s*\/\s*style\s*=\s*["']([^"']*)["']/gi,
        '<span style="$1"'
      );
      template = template.replace(/<span\s*\/\s+style\s*=/gi, "<span style=");
      template = template.replace(/<span\s*\/\s*>/gi, "<span>");
      template = template.replace(/<span\s*\/\s+([^>]*?)>/gi, "<span $1>");
      // Remove any remaining / before attributes in span tags
      template = template.replace(/<span\s+\/\s*([a-zA-Z-]+)/gi, "<span $1");

      let json;
      try {
        json = html2json(template);
      } catch (error) {
        // If html2json fails, try to remove any remaining problematic content
        console.warn("html2json parsing error, attempting to fix:", error);
        // Remove any remaining comment-like patterns
        template = template.replace(/<!--/g, "").replace(/-->/g, "");
        // Remove any CDATA sections that might cause issues
        template = template.replace(/<!\[CDATA\[[\s\S]*?\]\]>/g, "");
        try {
          json = html2json(template);
        } catch (retryError) {
          console.error("html2json failed after cleanup:", retryError);
          // Return a minimal valid JSON structure as fallback with proper node type
          json = { node: "root", tag: "div", child: [] };
        }
      }

      // Post-process JSON to fix any remaining issues with img tags and comment nodes
      // Sometimes html2json might still create invalid structures
      let fixJsonStructure = (node) => {
        if (!node) return;

        // Remove comment nodes that might cause issues
        if (node.node === "comment" || (node.tag && node.tag.toLowerCase() === "comment")) {
          // Comment nodes should not have children accessed, mark for removal
          node._shouldRemove = true;
          return;
        }

        if (node.tag === "img" && node.child && node.child.length > 0) {
          // img is void, cannot have children - convert to span
          node.tag = "span";
          // Add display:inline-block style if not present
          if (!node.attr) node.attr = {};
          if (!node.attr.style) {
            node.attr.style = "display:inline-block;";
          } else if (typeof node.attr.style === "string" && !node.attr.style.includes("display")) {
            node.attr.style = node.attr.style + "display:inline-block;";
          }
        }

        if (node.child && Array.isArray(node.child)) {
          // First, recursively fix all children
          node.child.forEach((child) => {
            if (child) {
              fixJsonStructure(child);
            }
          });

          // Then filter out comment nodes and null/undefined children
          node.child = node.child.filter((child) => {
            return (
              child !== null &&
              child !== undefined &&
              !child._shouldRemove &&
              child.node !== "comment" &&
              !(child.tag && child.tag.toLowerCase() === "comment")
            );
          });
        }
      };
      fixJsonStructure(json);

      parseJson(json, state, hasVisorTemplate);
      return json;
    },
    /* registerExtraFunction: function(fn, alias) {
            if (!alias) {
                Object.keys(descendant).forEach(function(prop) {
                    if (descendant[prop] === fn) {
                        alias = prop;
                    }
                });
            }
            extraFunctions[alias] = fn;
        },
        getExtraFunctions: function() {
            return Object.keys(extraFunctions);
        },*/
    getLocales: function (lang) {
      let currentLanguage = lang || IdealStudio.i18n.language || "tr";
      if (currentLanguage.indexOf("-") > -1) {
        currentLanguage = currentLanguage.split("-")[0];
      }
      try {
        let texts = require(
          "./../../plugins/" + this.getConfig().name + "/locales/" + currentLanguage
        );
        IdealStudio.i18n.addResourceBundle(currentLanguage, "translation", texts, true, false);
      } catch (e) {
        console.warn("Translations not found for language: " + currentLanguage);
      }
    },
    /* callExtraFunction: function(alias, fnAlias) {
            let element = $.find("[data-alias='" + alias + "']");
            if (element && extraFunctions && extraFunctions[fnAlias]) {
                extraFunctions[fnAlias](element[0]);
            }
        },*/
    afterRender: function (element, oldState) {
      if (descendant.afterRender) {
        descendant.afterRender(element, oldState);
      }
    },
  };

  return plugin;
}
